import React from "react";

const FormPrefixContext = React.createContext("");

export default FormPrefixContext;
